import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/lang/index.js'
import axios from '@/api/axios.js'
import api from '@/api/api.js'
import '@/antDesign'
import '@/scss/index.scss'
import contractInterface from '@/utils/newContracts'

Vue.config.productionTip = false
Vue.prototype.$contracts = contractInterface

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.use(axios, app)
Vue.use(api, app)
export { Vue }
